const KEY = 'platform_impersonation';

/** What the console remembers about the open impersonation (per tab): where to return to, the session to close, and when it ends. */
export interface ImpersonationStash {
  accountId?: number;
  accountName?: string;
  sessionId?: number;
  /** Epoch milliseconds at which the impersonation token stops working. */
  expiresAt?: number;
}

export function readStash(): ImpersonationStash | null {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) ?? 'null');
  } catch {
    return null;
  }
}

export function writeStash(stash: ImpersonationStash): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(stash));
  } catch {
    // storage unavailable: the banner and return path fall back to defaults
  }
}

export function clearStash(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // nothing to clear
  }
}

/** Where to go after an impersonation ends: the account the admin opened it from, else the console home. */
export function returnPath(fallback: string): string {
  const id = readStash()?.accountId;
  return id ? `/platform/accounts/${id}` : fallback;
}
